import { render, staticRenderFns } from "./CargoQuotePost.vue?vue&type=template&id=7a123d42&"
import script from "./CargoQuotePost.vue?vue&type=script&lang=js&"
export * from "./CargoQuotePost.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuotePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuotePost.vue"
export default component.exports